import { Image } from '@/features/shared/elements/Image/NextImage'
import { screenSizes } from '@shipt/design-system-themes'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'
import styled from 'styled-components'

export const GenericHero = () => {
  return (
    <HeroWrapper as="section">
      <HeroImageWrapper>
        <HeroImage
          src={objectStorageUrl('hero-generic.jpg')}
          width={1080}
          height={400}
          alt="Generic Shipt Kitchen"
          style={{ objectFit: 'cover' }}
        />
      </HeroImageWrapper>
    </HeroWrapper>
  )
}

const HeroWrapper = styled.section`
  display: flex;
  margin: 0 auto;
  justify-content: center;
`

const HeroImageWrapper = styled.div`
  margin-top: 1rem;

  & img {
    border-radius: 16px;
  }
`

const HeroImage = styled(Image)`
  @media ${screenSizes.max_mobile} {
    width: auto;
    height: auto;
  }
`
